module.exports = __webpack_public_path__ + "static/media/ktm-02.9f955263.jpg";